import { Action } from '@ngrx/store';
import {LicenseMgtList} from '../license-mgt.model';

export enum LicenseMgtListActionTypes {
  GetLicenseMgtLists = '[LicenseMgtList] Get LicenseMgtLists',
  LoadLicenseMgtLists = '[LicenseMgtList] Load LicenseMgtLists',
  UpsertLicenseMgtLists = '[LicenseMgtList] Upsert LicenseMgtLists',
  GetLicenseMgtListsFails = '[LicenseMgtList] Get LicenseMgtLists Fails',
  DeleteLicenseMgtLists = '[LicenseMgtList] Delete LicenseMgtLists',
  GetDeleteLicenseMgtLists = '[LicenseMgtList] Get Delete LicenseMgtLists',
  GetBindSNToLicenseMgtLists = '[LicenseMgtList] Get Bind SN To LicenseMgtLists'
}

export class GetLicenseMgtLists implements Action {
  readonly type = LicenseMgtListActionTypes.GetLicenseMgtLists;

  constructor(public payload: any = null) {}
}

export class LoadLicenseMgtLists implements Action {
  readonly type = LicenseMgtListActionTypes.LoadLicenseMgtLists;
  constructor(public payload: LicenseMgtList[]) {}
}

export class UpserLicenseMgtLists implements Action {
  readonly type = LicenseMgtListActionTypes.UpsertLicenseMgtLists;
  constructor(public payload: LicenseMgtList[]) {}
}

export class GetLicenseMgtListsFail implements Action {
  readonly type = LicenseMgtListActionTypes.GetLicenseMgtListsFails;
}

export class DeleteLicenseMgtLists implements Action {
  readonly type = LicenseMgtListActionTypes.DeleteLicenseMgtLists;
  constructor(public payload: { id: number }) {}
}

export class GetDeleteLicenseMgtLists implements Action {
  readonly type = LicenseMgtListActionTypes.GetDeleteLicenseMgtLists;
  constructor(public payload: { id: number }) {}
}

export class GetBindSNToLicenseMgtLists implements Action {
  readonly type = LicenseMgtListActionTypes.GetBindSNToLicenseMgtLists;
  constructor(public payload: { license?: number, sn?: string}) {}
}


export type LicenseMgtListActions = LoadLicenseMgtLists
  | GetLicenseMgtLists
  | UpserLicenseMgtLists
  | GetLicenseMgtListsFail
  | DeleteLicenseMgtLists
  | GetDeleteLicenseMgtLists
  | GetBindSNToLicenseMgtLists;
